<template>
  <label :class="wrapperClasses">
    <input
      type="checkbox"
      :class="controlClasses"
      :readOnly="isReadOnly"
      :checked="isChecked"
      :value="isChecked"
      :disabled="isDisabled"
      v-on="listeners"
    />
    <!-- <span :class="['checkmark', { 'event-none': readOnly }]"></span> -->
    <span v-if="showLabel" :class="textClasses">{{ label }}</span>
  </label>
</template>
<script>
import { defineComponent, computed, watch } from 'vue'
import { useCheckbox } from './composables/useCheckbox.js'
import { useCheckboxEvents } from './composables/useCheckboxEvents.js'
import { useCheckboxStyles } from './composables/useCheckboxStyles.js'

export default defineComponent({
  name: 'MsCheckbox',
  props: {
    modelValue: {
      default: false,
      type: [Boolean, Number],
    },
    label: {
      default: null,
      type: String,
    },
    disabled: {
      default: false,
      type: [Boolean, Function, String],
    },
    readOnly: {
      default: false,
      type: Boolean,
    },
    checked: {
      type: [Boolean, Number],
      default: false,
    },
    isShowLabel: {
      // có hiển thị label ko?
      type: Boolean,
      default: true,
    },
  },
  setup(props, { emit }) {
    // Core logic composable
    const checkboxState = useCheckbox(props)
    const { isChecked, isDisabled, isReadOnly } = checkboxState

    // Events composable - Giữ nguyên logic từ file gốc
    const { focused, onFocus, onBlur, listeners } = useCheckboxEvents(props, emit)

    // Styles composable
    const { wrapperClasses, controlClasses, textClasses, showLabel } = useCheckboxStyles(props, checkboxState)

    // Watch - Giữ nguyên từ file gốc
    watch(
      () => props.checked,
      () => {
        emit('checkedChange', props.checked, props.label)
      },
    )

    return {
      // State
      focused,
      isChecked,
      isDisabled,
      isReadOnly,
      
      // Methods
      onFocus,
      onBlur,
      listeners,
      
      // Styles
      wrapperClasses,
      controlClasses,
      textClasses,
      showLabel,
    }
  },
})
</script>
<style lang="scss" scoped>
@import '@/assets/scss/components/MsCheckbox.scss';
</style>
